export const EMAIL_TRACE = {
  common: {
    arrive_i18n: {
      event_type: 'arrive_i18n',
      event_action: 'arrive_i18n',
    },
  },
  // 账户拒审
  account_audit_rejected: [
    // 0 到达平台
    {
      event_type: 'arrive_i18n',
      event_action: 'arrive_i18n',
    },
    // 1 到达指定页面 - 账户信息页面 https://ads.tiktok.com/i18n/account/complete
    {
      event_type: 'arrive_destination',
      event_action: 'arrive_account_setup',
    },
    // 2 点击I want to appeal
    {
      event_type: 'user_complete',
      event_action: 'click_appeal',
    },
    // 3 点击I want to cancel my account and request a refund
    {
      event_type: 'click_cancel_account',
      event_action: 'click_cancel_account',
    },
  ],
  // 广告拒审
  ad_group_audit_rejected: [
    // 0 到达平台
    {
      event_type: 'arrive_i18n',
      event_action: 'arrive_i18n',
    },
    // 1 到达指定页面 - 定位到只显示被拒审Ad Group的列表页
    {
      event_type: 'arrive_destination',
      event_action: 'arrive_list',
    },
    // 2 查看广告 - 包括点击ad group名字，点击编辑，点击复制，点击拒审小三角
    {
      event_type: 'ad_check_out',
      event_action: 'ad_check_out',
    },
  ],
  // 账户余额耗尽
  account_balance_empty: [
    {
      event_type: 'arrive_i18n',
      event_action: 'arrive_i18n',
    },
    {
      event_type: 'arrive_destination',
      event_action: 'arrive_payment',
    },
    {
      event_type: 'user_complete',
      event_action: 'click_add_balance',
    },
    {
      event_type: 'action_success',
      event_action: 'add_balance_success',
    },
  ],
  // 账户余额接近耗尽
  account_balance_insufficient: [
    {
      event_type: 'arrive_i18n',
      event_action: 'arrive_i18n',
    },
    {
      event_type: 'arrive_destination',
      event_action: 'arrive_payment',
    },
    {
      event_type: 'user_complete',
      event_action: 'click_add_balance',
    },
    {
      event_type: 'action_success',
      event_action: 'add_balance_success',
    },
  ],
  // 未充值提醒
  first_creative_no_charge_deferred: [
    // 0 到达平台
    {
      event_type: 'arrive_i18n',
      event_action: 'arrive_i18n',
    },
  ],

  // smb扶持触达
  arrive_platform: [
    // 0 到达平台
    {
      event_type: 'arrive_i18n',
      event_action: 'arrive_i18n',
    },
    {
      event_type: 'arrive_platform',
      event_action: 'verify_submission', // 提交公司认证
    },
    {
      event_type: 'arrive_platform', // 提交一次性赠款
      event_action: 'grant_claim',
    },
  ],
};
